import React from 'react';
import styled from 'styled-components';

const PaginationWrapper = ({items}) => {

    const StyledPagination = styled.nav`
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: stretch;
        margin-top: 1em;
        height: ${props => props.theme.space[12]};
        color: ${props => props.theme.palette.blueGrey[300]};
        
        & .stolo-pager-notclickable {
          background-color: ${props => props.theme.palette.blueGrey[50]};
          cursor: not-allowed;
        }

        & .stolo-pager-active {
          border-bottom: 2px solid ${props => props.theme.palette.primary[500]};
        }
    `;


    return (
        <StyledPagination role="navigation">
            {items}
        </StyledPagination>
    );
};

export default PaginationWrapper;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PaginationWrapper.js